import { Component, Input, ElementRef } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-header',
  templateUrl: './header.component.html',
  host: {
    class: 'uex-card-header card-header'
  }
})
export class CardHeaderComponent {
  @Input('alignItems') public alignItems = 'start';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    public elementRef: ElementRef
  ) { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-card-header]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-card-header card-header'
  }
})
export class CardHeadingHeaderComponent {
  constructor() { }
}
